import { createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import { createSelector } from 'reselect';

const initialState = {
  loading: false,
  error: null,
  isAuthenticated: !!localStorage.getItem('AUTH_TOKEN'),
  token: localStorage.getItem('AUTH_TOKEN'),
  authInfo: localStorage.getItem('AUTH_TOKEN') ? jwtDecode(localStorage.getItem('AUTH_TOKEN')) : {},
  subscription: localStorage.getItem('SUBSCRIPTION') ? JSON.parse(localStorage.getItem('SUBSCRIPTION')) : {},
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.authInfo = jwtDecode(action.payload.token);
      state.subscription = action.payload.current_subscription;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      localStorage.removeItem('AUTH_TOKEN');
    },
  },
});

export const { loginRequest, loginSuccess, loginFailure, logout } = authSlice.actions;

const selectAuthState = (state) => state.auth;

export const selectUser = createSelector([selectAuthState], (auth) => auth.authInfo.user || {});
export const selectSubscription = createSelector([selectAuthState], (auth) => auth.subscription || {});

export default authSlice.reducer;
